var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCropUnhealthy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.10326 1.37418C1.12496 1.1537 1.31609 0.989184 1.53735 1.00056C8.30787 1.34851 14.0077 3.51185 17.8674 7.21493C21.7363 10.9268 23.7185 16.1509 23.1038 22.5258C23.0846 22.7251 22.9258 22.8822 22.7262 22.8993C14.9543 23.5631 9.26704 20.8849 5.66264 16.6621C2.06932 12.4522 0.575159 6.74183 1.10326 1.37418ZM1.89372 1.85177C1.49497 6.90605 2.95205 12.2085 6.29362 16.1235C9.65885 20.0661 14.9635 22.6353 22.3089 22.1002C22.798 16.1161 20.8949 11.2692 17.2931 7.81355C13.6871 4.35384 8.34229 2.2553 1.89372 1.85177Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5343 10.743C11.6559 10.5489 11.9118 10.4901 12.106 10.6117C14.423 12.0634 15.7997 14.1408 17.1353 16.1562C17.2217 16.2865 17.3079 16.4165 17.3941 16.5461C18.8253 18.6966 20.2891 20.7516 22.8843 22.119C23.087 22.2258 23.1647 22.4767 23.0579 22.6794C22.9511 22.882 22.7003 22.9597 22.4976 22.853C19.7005 21.3791 18.1385 19.1618 16.7035 17.0057C16.6234 16.8853 16.5437 16.7652 16.4642 16.6454C15.1099 14.604 13.8255 12.668 11.6655 11.3147C11.4714 11.1931 11.4126 10.9371 11.5343 10.743Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5546 19.1377C15.5781 18.9099 15.7818 18.7441 16.0097 18.7676L19.075 19.0828C19.3028 19.1062 19.4686 19.31 19.4451 19.5379C19.4217 19.7657 19.218 19.9315 18.9901 19.908L15.9248 19.5928C15.6969 19.5693 15.5312 19.3656 15.5546 19.1377Z",
    fill: "#FF0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4683 13.8032C10.485 13.5747 10.6838 13.4031 10.9123 13.4198L15.2676 13.7392C15.496 13.756 15.6677 13.9548 15.6509 14.1832C15.6341 14.4117 15.4354 14.5833 15.2069 14.5666L10.8516 14.2472C10.6231 14.2304 10.4515 14.0316 10.4683 13.8032Z",
    fill: "#FF0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.575 12.2264C17.8005 12.2667 17.9506 12.4822 17.9103 12.7077L17.23 16.5113C17.1897 16.7368 16.9742 16.887 16.7487 16.8466C16.5232 16.8063 16.3731 16.5908 16.4134 16.3653L17.0937 12.5617C17.134 12.3362 17.3495 12.1861 17.575 12.2264Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCropUnhealthy);
export default __webpack_public_path__ + "static/media/crop-unhealthy.34552844fa62794e2258da89b4e95b4f.svg";
export { ForwardRef as ReactComponent };